import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { useRedirectUrl } from 'util/hooks/useRedirectUrl';

// Selectors
import { isInitialLoadDone } from 'api/loading/selectors';

// Components
import LoadingWrapperContainer from 'api/loading/LoadingWrapperContainer';
import EditContainer from 'edit/EditContainerConnect';

let ScriptCreatorContainer = ({
  initialLoadIsInProgress
}) => {
  const redirectUrl = useRedirectUrl();

  return (
    <LoadingWrapperContainer initialLoadIsInProgress={initialLoadIsInProgress}>
      <EditContainer redirectUrl={redirectUrl} />
    </LoadingWrapperContainer>
  );
};

ScriptCreatorContainer.propTypes = {
  initialLoadIsInProgress: propTypes.bool.isRequired
};

ScriptCreatorContainer = connect(
  (state) => {
    const initialLoadIsInProgress = !isInitialLoadDone(state);

    return {
      initialLoadIsInProgress
    }; // if there's no script here, pass an undefined scriptId so the component knows not to render
  }
)(ScriptCreatorContainer);

export default ScriptCreatorContainer;
